export default {
  SET_STATE: 'activityLogs/SET_STATE',
  FETCH_ACTIVITY_LOGS: 'activityLogs/FETCH_ACTIVITY_LOGS',
}
